/**
 * What the summaries loaded beside the inbox list share: checks and auto-fix
 * each POST to their own route and refresh on realtime invalidation.
 */

/**
 * Freshness and persistence for a side-loaded summary. Realtime events
 * invalidate it; the stale time only covers a missed event.
 */
export const INBOX_V2_SIDE_LOAD_QUERY_OPTIONS = {
  staleTime: 30_000,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
  meta: { persist: true },
} as const;
